import { SVGProps } from 'react';

import css from './styles.module.css';

export function TimelineConnector(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={css.connectorSvg}
      aria-hidden
      viewBox="0 0 48 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      {...props}
    >
      <mask id="connector-mask">
        <path
          d="M12 0L12 2.10615C12 4.8014 13.7972 7.16589 16.3941 7.88726L31.6059 12.1127C34.2028 12.8341 36 15.1986 36 17.8938V19"
          stroke="white"
          strokeWidth={1}
          strokeLinecap="round"
          vectorEffect="non-scaling-stroke"
        />
      </mask>
    </svg>
  );
}
